<script lang="ts">


    import type {IMaintenance} from "../../data";
    import Revision from "../products/Revision.svelte";
    import {getFormatter, getSelectedCity} from "../../utils";
    import {onMount} from "svelte";
    import {Cart, getCart} from "../../models/cart";
    import {IMaintenancePrice} from "../../data";
    import Dialog, {Actions, Content} from "@smui/dialog";
    import NauiButton from "../../naui/atoms/NauiButton.svelte";

    export let maintenance: IMaintenance;
    export let cities: Array<any> = [];

    export let keys = {
        silver: {
            description: 'descSilver',
            precioTotal: 'precioSilverTotal',
            precioNeto: 'precioSilverNeto',
            porcDescuento: 'porcDescuentoSilver',
            vin: 'vin',
            codModeloTasa: 'codModeloTasa',
            ciudad: 'ciudad',
        },
        gold: {
            description: 'descGold',
            precioTotal: 'precioGoldTotal',
            precioNeto: 'precioGoldNeto',
            porcDescuento: 'porcDescuentoGold',
            vin: 'vin',
            codModeloTasa: 'codModeloTasa',
            ciudad: 'ciudad',
        }
    };

    export let key: string;

    export let plan: any = {};

    export let price: IMaintenancePrice;

    export let km: number;

    export let detailCmpt: any;

    const formatter = getFormatter();

    export let cart: Cart;

    export let wp_link: string;

    export let dialog: any = {
        open: false,
        message: ''
    }

    onMount(() => {
        getCart().then((c) => {
            cart = c;
        });
    })

    const isMobile = window.innerWidth < 768;

    function add() {
        const selectedCity = getSelectedCity();
        const plan_cart = {
            item: {
                reference: plan.id,
                vin: price.vin,
                codModeloTasa: price.codModeloTasa,
                image: plan.images[0].image,
                type: 'S',
                name: plan.title,
                km,
                route: `${location.pathname}`
            },
            quantity: 1,
            price: price.precioNeto,
            prevPrice: price.precioTotal,
            flag: price.porcDescuento > 0 ? `DCTO ${price.porcDescuento}%` : '',
            city: {
                id: selectedCity
            }
        };
        cart.addPlan(plan_cart);
        cart.update().then(() => {
            dialog.open = true;
            dialog.message = 'El plan ha sido agregado al carrito';
        }).catch(() => {
            dialog.open = true;
            dialog.message = 'Se presento un error agregando el plan al carrito';
        });
    }

    function closeDialog() {
        dialog.open = false;
        dialog.message = '';
    }

    async function showDetail(km) {
        const details = await fetch(`/backend/api/v2/ecommerce/mantenimiento-prepagado-revision/kilometros/${km}/`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        }).then(r => r.json());
        detailCmpt.$set({
            open: true,
            details
        });
    }

</script>

{#if maintenance}
    {#if isMobile}
        <div class="container">
            <img class="mx-auto" src="{plan.images[1].image}" alt="{plan.title}" style="width: 100%; max-width: 150px;">
        </div>
        <section class="pt-1 pb-2 product mx-25">
            <div class="container">
                <div class="grid-1-2 m:block">
                    <div>
                        <h1 class="mb-iii">{plan.title}</h1>
                    </div>
                    <div>
                        <div class="text-c mb-1 m:text-l m:mt-2">
                            {#if price.porcDescuento > 0}
                                <small>Antes {formatter(price.precioTotal)}</small>
                            {/if}
                            <div class="price">
                                {formatter(price.precioNeto)}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    {:else}
        <div class="pt-3" style="display: flex;">
            <div style="float: left; width: 70%;">
                <section class="pt-1 pb-2 product">
                    <div class="container">
                        <div class="grid-1-auto m:block">
                            <div>
                                <h1 class="mb-iii">{plan.title}</h1>
                            </div>
                            <div>
                                <div class="text-c mb-1 m:text-l m:mt-2">
                                    {#if price.porcDescuento > 0}
                                        <small>Antes {formatter(price.precioTotal)}</small>
                                    {/if}
                                    <div class="price">
                                        {formatter(price.precioNeto)}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
            <div style="float: left;">
                <div class="container">
                    <img src="{plan.images[1].image}" alt="{plan.title}" style="width: 100%; max-width: 500px;">
                </div>
            </div>
        </div>
    {/if}
    <div class="py-1 max-w-900px p-25">
        <section>
            <div class="mb-2">
                <div class="formatted">{plan.description}</div>
            </div>
            <div class="mb-2">
                <div class="formatted">{@html plan.service.text}</div>
            </div>
            <ul class="mb-2">
                {#each plan.service.data as item}
                    <li class="formatted">{@html item.text}</li>
                {/each}
            </ul>
        </section>
        <div class="mb-1">
            <strong>Revisiones Incluidas</strong>
        </div>
        <table class="nissan-table w-100">
            {#each price.description as item}
                <tr>
                    <td class="p-iii">Revisión {item} km</td>
                    <td class="p-iii">
                        <div class="box-r sx-i pointer" on:click={()=>showDetail(item)}>
                            <span style="font-size: 14px">Detalle</span>
                            <img height="15" src="/static/storefront/pix/icons/chevron-red.svg" alt="CTA">
                        </div>
                    </td>
                </tr>
            {/each}
        </table>
    </div>
    <Revision bind:this={detailCmpt}/>
    <div class="py-1 max-w-900px p-25 mx-3" style="display: flex; justify-content: center;">
        <div class="btn accent" on:click={()=>add()} style="float: left;">
            AGREGAR
        </div>
        <div class="btn-whatsapp-maintenance mx-2" style="float: left;">
            <a href="{wp_link}" target="_blank">
                <img src="/static/storefront/pix/icono-wapp-green.svg" alt="Whatsapp">
            </a>
        </div>
        <a href="{wp_link}" target="_blank" class="btn" style="background: #4DC246; float: left;">
            ASESORÍA
        </a>
    </div>
{/if}

<Dialog bind:open={dialog.open}
        scrimClickAction=""
        escapeKeyAction=""
        aria-describedby="mandatory-content">
    <Content id="mandatory-content">
        {dialog.message}
    </Content>
    <Actions>
        <div class="box sx-ii">
            <NauiButton caption="ACEPTAR"
                        color="accent"
                        mode="solid"
                        on:click={()=>closeDialog()}/>
        </div>
    </Actions>
</Dialog>

<style>
    .btn-whatsapp-maintenance {
        color: #ffffff;
        background-color: #4DC246;
        border-radius: 50%;
        width: 60px;
        height: 60px;
        padding: 10px;
        margin-top: -5px;
        display: flex;
        justify-content: center;
        align-items: center;
    }
</style>